import { SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import React, { useState } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const AddHowToItemForm = ({ loading, onSubmit }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    subject: '',
    description: '',
    is_internal: false,
    is_external: false,
  });

  const [pdfFile, setPdfFile] = useState(null);

  const allFieldsFilled =
  form.subject.trim() !== '' &&
  form.description.trim() !== '' &&
  (form.is_internal || form.is_external);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === 'pdf_file') setPdfFile(files[0]);
  };

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!allFieldsFilled) return;

		const formData = new FormData();
		formData.append('subject', form.subject);
		formData.append('description', form.description);
    formData.append('is_internal', form.is_internal);
    formData.append('is_external', form.is_external);

		if (pdfFile) formData.append('pdf_file', pdfFile);

		if (onSubmit) await onSubmit(formData);

		setForm({ subject: '', description: '', visibility: 'internal' });
		setPdfFile(null);
	};


  return (
    <Form
      onSubmit={handleSubmit}
      className="p-3 border rounded mb-4 bg-light"
      encType="multipart/form-data"
    >
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group controlId="subject">
            <Form.Label>{t('subject')}</Form.Label>
            <Form.Control
              type="text"
              name="subject"
              value={form.subject}
              onChange={handleChange}
              placeholder={t('enter_subject')}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <Form.Group controlId="description" className="mb-3">
        <Form.Label>{t('description')}</Form.Label>
        <Form.Control
          as="textarea"
          name="description"
          rows={3}
          value={form.description}
          onChange={handleChange}
          placeholder={t('enter_description')}
          required
        />
      </Form.Group>

      <Form.Group controlId="visibility" className="mb-3">
        <Form.Label>{t('visibility')}</Form.Label>
        <div>
          <Form.Check
            type="checkbox"
            label={t('internal')}
            name="is_internal"
            checked={form.is_internal}
            onChange={(e) => setForm({ ...form, is_internal: e.target.checked })}
          />
          <Form.Check
            type="checkbox"
            label={t('external')}
            name="is_external"
            checked={form.is_external}
            onChange={(e) => setForm({ ...form, is_external: e.target.checked })}
          />
        </div>
      </Form.Group>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Group controlId="pdf_file">
            <Form.Label>{t('pdf_file')}</Form.Label>
            <Form.Control
              type="file"
              name="pdf_file"
              accept="application/pdf"
              onChange={handleFileChange}
            />
            {pdfFile && (
              <small className="text-muted d-block mt-1">
                {pdfFile.name}
              </small>
            )}
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end">
        <SaveButton
          disabled={!allFieldsFilled || loading}
          text={loading ? t('creating') : t('create')}
        />
      </div>
    </Form>
  );
};

export default AddHowToItemForm;
